"use strict";

exports.__esModule = true;
exports.dataHooks = exports.SIZES = void 0;
var dataHooks = exports.dataHooks = {
  menuArrow: 'input-menu-arrow',
  status: 'input-status',
  statusIndicatorTooltip: 'status-indicator-tooltip',
  suffixes: 'input-suffixes',
  tooltip: 'input-suffix-tooltip'
};
var SIZES = exports.SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
//# sourceMappingURL=constants.js.map